import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TecnicoRilevatore } from '../models/models/pages/tecnico_rilevatore';


@Injectable({
    providedIn: 'root'
})
export class TecnicoRilevatoreService {
    private baseUrl = `${environment.baseApiUrl}/tecnico-rilevatore`;


    constructor(private http: HttpClient) { }

    list(): Observable<TecnicoRilevatore[]> {
        return this.http.get<TecnicoRilevatore[]>(this.baseUrl); // senza observe: 'response'
    }
}
